import { PopupWithButton, PopupWithButtonProps } from "manifest-components/src/Popup";
import { FunctionComponent } from "react";
import {
  SURVEY_POP_UP_CONTENT_LOCATE_OLD_ACCOUNT,
  SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_1,
  SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_2,
  SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_1,
  SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_2,
} from "../../pages/Vendor/constants";
import { SurveyResult } from "../../pages/Vendor/typings/Survey";

interface EmailSurveyResultPopupProps extends PopupWithButtonProps {
  result: SurveyResult;
  goToVendorSite: () => void;
}

const EmailSurveyResultPopup: FunctionComponent<EmailSurveyResultPopupProps> = ({
  result,
  goToVendorSite,
  ...popupProps
}: EmailSurveyResultPopupProps) => {
  const getHeaderString = (popupContent: SurveyResult): string | undefined => {
    switch (popupContent) {
      case SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_1:
      case SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_2:
        return "You don’t need our help right now. But that could change!";
      case SURVEY_POP_UP_CONTENT_LOCATE_OLD_ACCOUNT:
        return "Let us find your account for you";
      case SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_1:
      case SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_2:
        return "Let us transfer your account for you";
      default:
        return undefined;
    }
  };

  const getContent = (popupContent: SurveyResult): JSX.Element => {
    switch (popupContent) {
      case SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_1:
        return (
          <p>
            <a href="https://retirementnuggets.substack.com/" target="_blank" rel="noreferrer">
              Subscribe to our newsletter
            </a>
            , Retirement Nuggets; we’ll keep you up to date on our company’s work and impact on the retirement industry!
          </p>
        );
      case SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_2:
        return (
          <>
            <p>You’re one step ahead of us! Congratulations on successfully consolidating your retirement accounts.</p>
            <br />
            <p>
              <a href="https://retirementnuggets.substack.com/" target="_blank" rel="noreferrer">
                Subscribe to our newsletter
              </a>
              , Retirement Nuggets; we’ll keep you up to date on our company’s work and impact on the retirement
              industry!
            </p>
          </>
        );
      case SURVEY_POP_UP_CONTENT_LOCATE_OLD_ACCOUNT:
        return (
          <>
            <p>Not sure about your old accounts? That’s normal - the retirement industry is SO complicated!</p>
            <br />
            <p>
              Here’s what we’ll do when you set up an account with us: we’ll <strong>locate</strong> your old account,
              and if there’s money there, we’ll <strong>transfer it to your current plan!</strong>
            </p>
            <br />
            <p>
              Without Manifest, this transfer could take up to 8 hours.{" "}
              <strong>With us, it’s less than 10 minutes!</strong>
            </p>
          </>
        );
      case SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_1:
        return (
          <>
            <p>
              Even though you may not have made any contributions, your employer might have! 98% of employers offering a
              401(k) offer some kind of matching contributions.
            </p>
            <br />
            <p>
              Here’s what we’ll do when you set up an account with us: we’ll <strong>locate</strong> your old account,
              and if there’s money there, we’ll <strong>transfer it to your current plan!</strong>
            </p>
            <br />
            <p>
              Without Manifest, this transfer could take up to 8 hours.{" "}
              <strong>With us, it’s less than 10 minutes!</strong>
            </p>
          </>
        );
      case SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_2:
        return (
          <>
            <p>
              Bringing all your old retirement accounts into one plan can grow your balance an{" "}
              <strong>additional 36% over 10 years</strong>.
            </p>
            <br />
            <p>
              {" "}
              Without Manifest, this transfer could take up to 8 hours.{" "}
              <strong>With us, it’s less than 10 minutes!</strong>
            </p>
            <br />
            <p>What are you waiting for? Start your transfer today, and grow your savings by tomorrow.</p>
          </>
        );
      default:
        return <></>;
    }
  };

  const getButtonProps = (popupContent: SurveyResult): Partial<PopupWithButtonProps> => {
    switch (popupContent) {
      case SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_1:
      case SURVEY_POP_UP_CONTENT_SUBSCRIBE_THE_NEST_2:
        return {
          showButtonOne: true,
          buttonOneText: "Visit The Nest",
          buttonOneHandler: () => window.open("https://retirementnuggets.substack.com/", "_blank"), // TODO: Ask Riley if he wants to track
        };
      case SURVEY_POP_UP_CONTENT_LOCATE_OLD_ACCOUNT:
      case SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_1:
      case SURVEY_POP_UP_CONTENT_TRANSFER_YOUR_ACCOUNT_2:
        return {
          showButtonOne: true,
          buttonOneText: "Get started",
          buttonOneHandler: goToVendorSite,
        };
      default:
        return {
          showButtonOne: false,
        };
    }
  };

  return (
    <PopupWithButton
      header={
        <>
          <strong>Result: </strong>
          <span style={{ fontWeight: "400" }}>{getHeaderString(result)}</span>
        </>
      }
      content={getContent(result)}
      handlePopup={goToVendorSite}
      showClose
      showPopup
      {...getButtonProps(result)}
      {...popupProps}
    />
  );
};

export default EmailSurveyResultPopup;
